import { render, staticRenderFns } from "./OlympicsStats.vue?vue&type=template&id=29e27a38&"
import script from "./OlympicsStats.vue?vue&type=script&lang=js&"
export * from "./OlympicsStats.vue?vue&type=script&lang=js&"
import style0 from "./OlympicsStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports